import ObjectStorage from '../../../../../common/ObjectStorage';
import CryptoJS from "crypto-js";
export default {
  // 获取秒时间戳
  getTimestamp(){
    return Math.round(new Date().getTime() / 1000);
  },

  bucket_name: 'law' ,

  // 上传文件
  uploadFile(file , callback) {
    ObjectStorage.getOssConfig(config => {
      let oss = new ObjectStorage(config)
      oss.setBucket(this.bucket_name)
      let date = new Date();
      let date_path = date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate() + '/';
      oss.upload(file , date_path + file.name , callback);
    });
  },

  // 获取文件预览地址
  getFileUrl(path) {
    // 判断文件是否是图片
    let imageExt = [
      'jpg' , 'png' , 'jpeg' , 'gif' , 'bmp' , 'webp' ,
      'JPG' , 'PNG' , 'JPEG' , 'GIF' , 'BMP' , 'WEBP' ,
    ];
    // 非图片文件自动下载
    if(imageExt.indexOf(path.split('.').pop()) === -1)
    {
      ObjectStorage.getOssConfig(config => {
        let oss = new ObjectStorage(config)
        oss.setBucket(this.bucket_name).setKey(path).download();
      });
    }
    let bucket = 'law'
    let duration_time = 3600
    let wordArray = CryptoJS.enc.Utf8.parse(path);
    let word=CryptoJS.enc.Base64.stringify(wordArray);
    return 'https://oss.gdzawy.com:9001/onlinePreviewObject?url='+encodeURIComponent(word)+'&bucket='+bucket+'&duration_time='+duration_time
  },

  // 案件费用类型
  caseFillType(){
    // 律师费、诉讼费、保全费、担保费、评估费
    return {
      1 : '诉讼费',
      // 2 : '一审受理费',
      // 3 : '二审上诉费',
      // 4 : '仲裁申请费',
      5 : '律师费',
      // 6 : '申请撤销仲裁受理费',
      7 : '保全费',
      8 : '担保费',
      9 : '评估费',
      10 : '其他'
    };
  },

  // 案件类型
  flowType(){
    return {
      'submit_court' : '提交法院',
      'accept' : '受理成功',
      'reject' : '拒绝受理',
      'preservation' : '诉讼保全',
      'court' : '开庭记录',
      'appeal' : '上诉申请',
      'fill' : '诉讼费用',
      'mediation' : '调解过程',
      'discount' : '折扣申请',
      'execute' : '案件执行',
      'close' : '回款结案',
      'pay' :'案件执行',
      'file' : '资料盖章',
    }
  },

  flowKey(){
    return {
      'notice_type' : '立案类型',
      'notice_no' : '立案号',
      'notice_file' : '受理通知/调解通知等',
      'time_type' : '诉讼期限',
      'sue_date' : '时间',
      'sue_no' : '开庭案号',
      'sue_level' : '开庭阶段',
      'is_seal' : '是否需要盖章',
      'content' : '案件当前情况',
      'sue_file' : '起诉状',
      'answer_file' : '答辩状',
      'proof_file' : '申请书',
      'proof_list' : '证据列表',
      'auth_file' : '委托手续',
      'safe_file' : '诉讼保全资料',
      'other_file' : '其他资料',
      'sue_content' : '审批内容',
      'apply_file' : '资料上传',
      'court_result' : '调解/判决结果/处理建议',
      'court_result_file' : '判决书/调解书',
      'fill_type' : '费用类型',
      'fill_money' : '费用金额',
      'fill_date' : '费用期限',
      'invoice_no' : '票据号',
      'file' : '上传文件',
      'judgment_file' : '判决书/裁决书/调解书',
      'pay_money' : '执行金额',
      'pay_content' : '金额来源',
      'follow_user' : '跟进人',
      'mediation_type' : '调解类型',
      'mediation_method' : '调解方式',
      'mediation_date' : '调解时间',
      'mediation_result' : '调解结果',
      'mediation_remark' : '调解备注',
      'mediation_file' : '调解文件',
      'preservation_date' : '保全时间',
      'preservation_amount' : '保全金额',
      'preservation_remark' : '保全备注',
      'preservation_file' : '保全文件',
      'court_date' : '开庭时间',
      'court_location' : '开庭地点',
      'court_judge' : '审判人员',
      'court_remark' : '开庭备注',
      'court_file' : '开庭文件',
      'appeal_date' : '上诉时间',
      'appeal_reason' : '上诉理由',
      'appeal_file' : '上诉文件',
      'pay_type' : '执行类型',
      'execute_date' : '执行日期',
      'execute_result' : '执行结果',
      'pay_method' : '回款方式',
      'remark' : '备注',
      'discount_rate' : '折扣比例',
      'trial_stage': '案件阶段',
    };
  },

  // 流程数据格式化显示
  flowData(data){
    if (!data || typeof data !== 'object') return '';
    let flowKey = this.flowKey();
    let keys = Object.keys(data);
    let result = '';
    keys.forEach(key => {
      if(flowKey.hasOwnProperty(key)){
        let dataValue = data[key];
        if(key == 'fill_type'){
          dataValue = this.caseFillType()[dataValue];
        }
        if(key == 'is_seal'){
          dataValue = dataValue == '1' ? '是' : '否';
        }
        if(key == 'mediation_type'){
          dataValue = dataValue == 'pre' ? '诉前调解' : '诉中调解';
        }
        if(key == 'mediation_method'){
          const methodMap = {
            'community': '社区调解',
            'moot_hall': '矛厅调解',
            'court_extra': '法院编外人员调解'
          };
          dataValue = methodMap[dataValue] || dataValue;
        }
        if(key == 'mediation_result'){
          const methodMap = {
            'success': '调解成功',
            'failed': '调解失败',
            'pending' : '调解中',
          }
          dataValue = methodMap[dataValue] || dataValue;
        }
        if(key == 'court_result'){
          const methodMap = {
            'adjourn': '休庭',
            'verdict': '判决',
            'mediation' : '调解',
          }
          dataValue = methodMap[dataValue] || dataValue;
        }
        if(key == 'pay_type'){
          dataValue = '案件执行';
        }
        if(key == 'execute_result'){
          const methodMap = {
            'success': '执行成功',
            'failed': '执行失败',
            'partial' : '部分执行',
            'pending' : '执行中',
          }
          dataValue = methodMap[dataValue] || dataValue;
        }
        if(key == 'pay_method'){
          const methodMap = {
            'cash': '现金',
            'bank': '银行转账',
            'wechat' : '微信支付',
            'alipay' : '支付宝支付',
            'other' : '其他',
          }
          dataValue = methodMap[dataValue] || dataValue;
        }
        if(key == 'trial_stage'){
          const methodMap = ['', '仲裁', '人民法院-一审', '人民法院-二审', '高级法院-再审', '检察院']
          dataValue = methodMap[dataValue] || dataValue;
        }
        result += flowKey[key] + ':' + dataValue + "; "
      }
    });
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/Butler/components/law_case/case.js